<template>
  <dialog
    ref="filterDialog"
    class="staff-reminder-filter-dialog"
    aria-labelledby="public-reminder-filter-title"
    aria-describedby="public-reminder-filter-description"
    @cancel.prevent="requestClose"
    @close="requestClose"
    @click.self="handleBackdropClick"
  >
    <header class="staff-reminder-filter-header">
      <span class="material-icons staff-reminder-filter-heading-icon" aria-hidden="true">tune</span>
      <div>
        <h2 id="public-reminder-filter-title">Filtra i promemoria</h2>
        <p id="public-reminder-filter-description">Scegli il periodo e affina la ricerca.</p>
      </div>
      <button type="button" class="staff-reminder-filter-close staff-button-neutral" aria-label="Chiudi filtri" title="Chiudi filtri" @click="requestClose" autofocus>
        <span class="material-icons" aria-hidden="true">close</span>
      </button>
    </header>

    <form class="staff-reminder-filter-form" @submit.prevent="handleSearchClick">
      <div class="staff-reminder-filter-body">
        <fieldset class="staff-reminder-filter-section">
          <legend>Periodo</legend>
          <div class="staff-reminder-filter-grid staff-reminder-filter-grid--two">
            <label class="staff-reminder-filter-field">
              <span>Dal giorno</span>
              <input type="date" v-model="selectedFilters.startDate" />
            </label>
            <label class="staff-reminder-filter-field">
              <span>Al giorno</span>
              <input type="date" v-model="selectedFilters.endDate" />
            </label>
          </div>
        </fieldset>

        <fieldset class="staff-reminder-filter-section">
          <legend>Attività</legend>
          <div class="staff-reminder-filter-grid staff-reminder-filter-grid--three">
            <label class="staff-reminder-filter-field">
              <span>Tipo di attività</span>
              <select v-model="selectedFilters.tipo">
                <option value="">Tutti</option>
                <option value="telefonata">Chiamata</option>
                <option value="prima telefonata">Prima chiamata</option>
                <option value="whatsapp">Whatsapp</option>
                <option value="email">E-mail</option>
                <option value="live">Dal vivo</option>
                <option value="messaggio">Messaggio</option>
                <option value="check confronto">Check di confronto</option>
                <option value="check lavorare">Check lavorare</option>
                <option value="ricontatto intermedio">Ricontatto intermedio</option>
                <option value="ricontatto finale">Ricontatto finale</option>
                <option value="recupero clienti fermi">Recupero clienti fermi</option>
                <option value="altro">Altro</option>
              </select>
            </label>
            <label class="staff-reminder-filter-field">
              <span>Stato</span>
              <select v-model="selectedFilters.fatto">
                <option value="">Tutti</option>
                <option value="si">Fatto</option>
                <option value="da fare">Da fare</option>
              </select>
            </label>
            <label class="staff-reminder-filter-field">
              <span>Urgenza</span>
              <select v-model="selectedFilters.urgenza">
                <option value="">Tutte</option>
                <option value="bassa">Bassa</option>
                <option value="media">Media</option>
                <option value="alta">Alta</option>
              </select>
            </label>
          </div>
        </fieldset>

        <fieldset class="staff-reminder-filter-section">
          <legend>Persone e assegnazioni</legend>
          <div class="staff-reminder-filter-grid staff-reminder-filter-grid--two">
            <div class="staff-reminder-filter-field" ref="dropdownContainer" @keydown.esc="handleStudioEscape">
              <span id="public-reminder-studio-label">Studio</span>
              <button
                type="button"
                class="staff-reminder-studio-trigger staff-button-neutral"
                aria-labelledby="public-reminder-studio-label public-reminder-studio-value"
                aria-controls="public-reminder-studio-options"
                :aria-expanded="dropdownOpen"
                @click="toggleDropdown"
              >
                <span id="public-reminder-studio-value" :title="selectedFilters.studio.join(', ')">{{ selectedFilters.studio.length ? selectedFilters.studio.join(', ') : 'Tutti gli studi' }}</span>
                <span class="material-icons" aria-hidden="true">{{ dropdownOpen ? 'expand_less' : 'expand_more' }}</span>
              </button>
              <div v-if="dropdownOpen" id="public-reminder-studio-options" class="staff-reminder-studio-options" role="group" aria-labelledby="public-reminder-studio-label">
                <label v-for="option in studioOptions" :key="option" class="staff-reminder-studio-option">
                  <input type="checkbox" :value="option" v-model="selectedFilters.studio" />
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
            <label class="staff-reminder-filter-field">
              <span>Email utente</span>
              <input v-model="selectedFilters.email" type="text" inputmode="email" placeholder="Email dell’utente" />
            </label>
            <label class="staff-reminder-filter-field">
              <span>Assegnato a</span>
              <input v-model="selectedFilters.assignedEmail" type="text" inputmode="email" placeholder="Email del collaboratore" />
            </label>
            <label class="staff-reminder-filter-field">
              <span>Fatto da</span>
              <select v-model="selectedFilters.da">
                <option value="">Tutti</option>
                <option value="paolo m.">paolo m.</option>
                <option value="paolo r.">paolo r.</option>
                <option value="gaetano">gaetano</option>
                <option value="luca c.">luca c.</option>
                <option value="roberta">roberta</option>
                <option value="pasquale">pasquale</option>
                <option value="stefania">stefania</option>
                <option value="salvatore">salvatore</option>
                <option value="luca d.">luca d.</option>
                <option value="giuseppe">giuseppe</option>
                <option value="Alessandro">Alessandro</option>
                <option value="mirko">mirko</option>
                <option value="michele">michele</option>
                <option value="sede">sede</option>
              </select>
            </label>
          </div>
        </fieldset>
      </div>
      <footer class="staff-reminder-filter-footer">
        <p>Le modifiche si applicano con Cerca.</p>
        <div class="staff-reminder-filter-actions">
          <button type="button" @click="resetFilters" :disabled="busy" class="staff-reminder-filter-button staff-reminder-filter-reset staff-button-neutral" title="Ripristina i promemoria da fare, da oggi ai prossimi 4 giorni">
            <span class="material-icons" aria-hidden="true">restart_alt</span>
            <span>Reset</span>
          </button>
          <button type="submit" :disabled="busy" class="staff-reminder-filter-button staff-reminder-filter-apply">
            <span class="material-icons" aria-hidden="true">search</span>
            <span>Cerca</span>
          </button>
        </div>
      </footer>
    </form>
  </dialog>
</template>

<script>
import { createPublicReminderFilters } from '../../lib/publicReminderFilters';

export default {
  emits: ['start-advanced-search', 'close'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    busy: {
      type: Boolean,
      default: false
    },
    initialFilters: {
      type: Object,
      default: () => createPublicReminderFilters()
    }
  },
  data() {
    return {
      dropdownOpen: false,
      studioOptions: [
        "Tivoli Quartier generale",
        "FF Genova",
        "FF Bologna",
        "FF Bari",
        "FF Pescara",
        "FF Firenze",
        "FF Torino",
        "FF Napoli",
        "FF Milano",
        "FF Roma",
        "FF Salerno",
        "FF Cagliari",
        "FF Milano Citta Studi",
        "FF Roma Eur",
        "FF Milano Sempione",
        "FF Padova"
      ],
      daOptions: [
        "",
        "paolo m.",
        "paolo r.",
        "gaetano",
        "luca c.",
        "roberta",
        "pasquale",
        "stefania",
        "salvatore",
        "luca d.",
        "giuseppe",
        "Alessandro",
        "mirko",
        "michele",
        "sede"
      ],
      selectedFilters: {
        ...this.initialFilters,
        studio: [...this.initialFilters.studio]
      }
    };
  },
  watch: {
    visible() {
      this.$nextTick(this.syncVisibility);
    }
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    this.syncVisibility();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    syncVisibility() {
      const dialog = this.$refs.filterDialog;
      if (!dialog) return;
      if (this.visible && !dialog.open) dialog.showModal();
      else if (!this.visible && dialog.open) dialog.close();
      if (!this.visible) this.closeDropdown();
    },
    requestClose() {
      this.$emit('close');
    },
    handleBackdropClick(event) {
      const rect = this.$refs.filterDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
        this.requestClose();
      }
    },
    handleStudioEscape(event) {
      if (!this.dropdownOpen) return;
      event.preventDefault();
      event.stopPropagation();
      this.closeDropdown();
    },
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    closeDropdown() {
      this.dropdownOpen = false;
    },
    handleClickOutside(event) {
      const dropdown = this.$refs.dropdownContainer;
      if (dropdown && !dropdown.contains(event.target)) {
        this.closeDropdown();
      }
    },
    resetFilters() {
      if (this.busy) return;
      this.selectedFilters = createPublicReminderFilters();
      this.$emit("start-advanced-search", this.selectedFilters);
    },
    handleSearchClick() {
      if (this.busy) return;
      this.$emit("start-advanced-search", this.selectedFilters);
    },
    scrollToBottom() {
      const table = document.querySelector("table");
      if (table) table.scrollIntoView({ behavior: "smooth", block: "end" });
    },
    scrollToTop() {
      const table = document.querySelector("table");
      if (table) table.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
};
</script>

<style scoped src="../../assets/css/staff-reminder-filters.css"></style>
